import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { resources } from './translations';

i18n.use(LanguageDetector).init({
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  },
  detection: {
    caches: ['cookie'],
    order: ['navigator', 'htmlTag', 'path', 'subdomain']
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  keySeparator: '.', // use '.' to access nested values in your translation files
  nsSeparator: ':', // use ':' to namespace your translations
  resources,
  supportedLngs: ['en', 'fr', 'fr-BE', 'es', 'it']
});

export default i18n;
